// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NcVeQ","footer-top":"Footer_footer-top__OpoqG"};